import { OrdersSidebarSection } from '../orders-sidebar-section';
import { getSummarySectionSummary } from './get-summary-section-summary';
import { SummarySectionContent } from './summary-section-content';
import { SummarySectionHeaderContent } from './summary-section-header-content';
import { useSellerFormattedDate } from '../../../../hooks/use-datetime-formats';

/**
 * @param {object} props
 * @param {object} [props.amountSummary]
 * @param {object[]} [props.discounts]
 * @param {object} [props.dragHandleProps]
 * @param {string[]} [props.fulfillmentPlanIds]
 * @param {string} [props.holdUntilDateTime]
 * @param {boolean} [props.open]
 * @param {(open: boolean) => void} [props.onClick]
 * @param {string} [props.orderDateTime]
 * @param {string} [props.orderGridStatus]
 * @param {string} [props.paidDateTime]
 * @param {object[]} [props.salesOrders]
 * @param {string} [props.shipByDateTime]
 * @param {string[]} [props.premiumPrograms]
 * @returns {JSX.Element}
 */
export const SummarySection = ({
  amountSummary,
  discounts,
  dragHandleProps,
  fulfillmentPlanIds,
  holdUntilDateTime,
  open,
  onClick,
  orderDateTime,
  orderGridStatus,
  paidDateTime,
  salesOrders,
  shipByDateTime,
  premiumPrograms,
}) => {
  const userFriendlyOrderDate = useSellerFormattedDate(orderDateTime);

  const headerContent = <SummarySectionHeaderContent premiumPrograms={premiumPrograms} />;

  const sectionContent = (
    <SummarySectionContent
      amountSummary={amountSummary}
      discounts={discounts}
      fulfillmentPlanIds={fulfillmentPlanIds}
      holdUntilDateTime={holdUntilDateTime}
      orderDateTime={orderDateTime}
      orderGridStatus={orderGridStatus}
      paidDateTime={paidDateTime}
      salesOrders={salesOrders}
      shipByDateTime={shipByDateTime}
    />
  );

  return (
    <OrdersSidebarSection
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      summaryData={getSummarySectionSummary(open, userFriendlyOrderDate, amountSummary)}
      toggleIsExpanded={onClick}
    />
  );
};
